import Constant from '@/common/constant/Constant';
import { Button, TextField } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import React, { useEffect } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import AddIcon from '@material-ui/icons/Add';
import './styles/EditionList.css';
import { EditionListStyle } from './styles/EditionListStyle';
import { useState } from 'react';
import ListItemEdition from './element/EditionListElement/ListItemEdition.js';
import { getListEditionData, handleBlurProductName, handleChangeProductName, isDisabledButtonSubmit, onCancelResetData, onClickCancelEdit, onClickYesCancel, onReloadPage, onSubmitData } from './handler/EditionListHandler';
import { userAtom } from '@/state/atom/userAtom';
import { useSnackbar } from 'notistack';
import LoadingPanel from '../common/LoadingPanel';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
// import { editionAtom } from '@/state/atom/productManagementAtom';
import { closePanelTabSelector } from '@/state/selector/panelSelector';
import { updatePanelInitData } from '../multiPanel/panel/handler/PanelHandler';
import { panelInitDataAtom } from '@/state/atom/panelAtom';
import { productManagementAtom } from '@/state/atom/productManagementAtom';
import ProductManagementConstant from '@/common/constant/ProductManagementConstant';


export default function EditionList(props) {
    const classes = EditionListStyle();

    const [editionList, setEditionList] = useState([]);
    const [editionListDefault, setEditionListDefault] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [triggerReload, setTriggerReload] = useState('');

    //groups editing actions
    const [isEdit, setIsEdit] = useState(false);

    const [isShowPopUpCancel, setIsShowPopUpCancel] = useState(false);
    const [hasError, setHasError] = useState(false);

    const userDetail = useRecoilValue(userAtom);
    const { enqueueSnackbar } = useSnackbar();
    const [isClosePanelProduct, setIsClosePanelProduct] = useRecoilState(productManagementAtom);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [panelInitData, setPanelInitData] = useRecoilState(panelInitDataAtom);
    const [isShowPopUpReload, setIsShowPopUpReload] = useState({isOpen: false, message: ''});
    const [nameProduct, setNameProduct] = useState({});
    const [nameProductDefault, setNameProductDefault] = useState({})
    const [listVersionUpdated, setListVersionUpdated] = useState([]);
    const [orderItem, setOrderItem] = useState(0);

    useEffect(() => {
        if (!props?.dataProduct?.id) return;
        (async () => {
            await getListEditionData(
                props?.API,
                setEditionList,
                setIsLoading,
                setEditionListDefault,
                props.dataProduct.id,
                props.setOpenDropDownVersion,
                props.openDropDownVersion,
                setNameProduct,
                setNameProductDefault,
                setOrderItem
            );
        })();
    }, [triggerReload, props.dataProduct]);

    useEffect(() => {
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'isEditedData', isEdit);
    }, [isEdit])

    const renderGroupButtonSubmit = () => {
        return (
            <div className="editionlist-header-wrapper">
                <div className="pl-16px pr-16px edition-header-container">
                    <div className="title-edition-list">{I18n.get('TITLE-EDIT-PRODUCT')}</div>
                    <div>
                        <Button
                            className="btn-send btn-light btn-hg32"
                            variant="contained"
                            color="primary"
                            onClick={() => onClickCancelEdit(setIsShowPopUpCancel, isEdit, props.onOpenVersionList)}
                        >
                            {I18n.get('COMBTN001')}
                        </Button>
                        <Button
                            className="btn-send btn-primary btn-hg32"
                            variant="contained"
                            color="primary"
                            data-cy="btn-submit-add-ticket"
                            disabled={isDisabledButtonSubmit(
                                hasError,
                                editionList,
                                isEdit,
                                editionListDefault,
                                listVersionUpdated,
                                nameProduct,
                                nameProductDefault
                            )}
                            onClick={async () =>
                                await onSubmitData(
                                    props?.API,
                                    editionList,
                                    setEditionList,
                                    setIsLoading,
                                    setTriggerReload,
                                    userDetail.id,
                                    setIsEdit,
                                    enqueueSnackbar,
                                    setHasError,
                                    props.dataProduct.id,
                                    nameProduct,
                                    setIsShowPopUpReload,
                                    listVersionUpdated,
                                    setNameProduct,
                                    setListVersionUpdated
                                )
                            }
                        >
                            {I18n.get('COMBTN011')}
                        </Button>
                    </div>
                </div>
            </div>
        );
    };

    const renderTblEditionList = () => {
        let tbl = (
            <div className="table-tbl table-tbl--account">
                <div style={{borderCollapse: 'separate', borderSpacing: 0, height:'100%'}}>
                    <div className='title-edition'>
                        <label className='trial-edition'>{I18n.get('LABEL-TABLE-ELECT-TRIAL-EDITION')}</label>
                        <label className='name-edition'>{I18n.get('LABEL-TABLE-EDITION-NAME')}</label>
                        <label className='status-edition'>{I18n.get('CM-LABEL-TABLE-SALES-STATUS')}</label>
                    </div>
                    <ListItemEdition 
                        editionList={editionList}
                        setEditionList={setEditionList}
                        onOpenVersionList={props.onOpenVersionList}
                        setHasError={setHasError}
                        setIsEdit={setIsEdit}
                        hasError={hasError}
                        openDropDownVersion={props.openDropDownVersion}
                        setOpenDropDownVersion={props.setOpenDropDownVersion}
                        nameProduct={nameProduct.name}
                        setListVersionUpdated={setListVersionUpdated}
                        isEdit={isEdit}
                        setOrderItem={setOrderItem}
                        listGptModel={props.listGptModel}
                    />
                </div>
            </div>
        );
        return tbl;
    }

    const addNewLineEdition = async () => {
        await handleAddNew();
    }

    const handleAddNew = async () => {
        const newEdition = {};
        newEdition.id = Date.now().toString();
        newEdition.name = '';
        newEdition.status = '';
        newEdition.isTrial = false;
        newEdition.createNewLine = true;
        newEdition.order = orderItem;
        newEdition.productId = props.dataProduct.id;

        setIsEdit(true);
        setOrderItem(prev => prev + 1);
        setEditionList(prev => [newEdition, ...prev]);
    };

    return (
        <div className='edition-list'>
            <LoadingPanel isLoading={isLoading} />
            {/* button cancel and submit  */}
            {renderGroupButtonSubmit()}

            {/* button add new edition */}
            <div className="edition-btn-add-newline pl-16px pr-16px">
                <TextField
                    className="form-control-wrapInput form-control-hg32 mgr-8px"
                    fullWidth
                    variant="outlined"
                    placeholder={I18n.get('CM-PLACEHODER-PRODUCT-NAME')}
                    value={nameProduct?.name}
                    error={nameProduct?.error}
                    helperText={I18n.get(nameProduct?.error)?.replace(
                        '{{maxLength}}',
                        ProductManagementConstant.MAX_LENGTH_NAME
                    )}
                    onChange={e =>
                        handleChangeProductName(e, setNameProduct, setHasError, setIsEdit)
                    }
                    onBlur={e => handleBlurProductName(e, setNameProduct, setHasError)}
                />
                
                <Button 
                    variant="text" 
                    startIcon={<AddIcon />} 
                    className={classes.buttonAddNewLine}
                    onClick={addNewLineEdition}
                >
                    {I18n.get('BUTTON-ADD-EDITION')}
                </Button>
            </div>
            {/* edition list */}
            <div className="group-edition">
                <div className="edition-table">{editionList && renderTblEditionList()}</div>
            </div>
            <ConfirmDialog
                isOpen={isShowPopUpCancel}
                msgConfirm={I18n.get('MSG-CM-CONFIRM-EXIT-PAGE-WITHOUT-SAVING')}
                okCallBack={async () =>
                    await onClickYesCancel(
                        props?.API,
                        editionList, 
                        setEditionList,
                        setIsLoading,
                        setTriggerReload,
                        userDetail.id,
                        setIsEdit,
                        enqueueSnackbar,
                        setHasError,
                        setIsShowPopUpCancel,
                        hasError,
                        isEdit,
                        props.dataProduct.id,
                        setIsClosePanelProduct,
                        nameProduct,
                        setIsShowPopUpReload,
                        listVersionUpdated,
                        setNameProduct,
                        setListVersionUpdated
                    )
                }
                closeCallBack={() => onCancelResetData(
                    setIsShowPopUpCancel,
                    props.onOpenVersionList
                )}
                cancelCallBack={() => {
                    setIsShowPopUpCancel(false);
                }}
                textSubmit={I18n.get('COMBTN002')}
                textClose={I18n.get('COMBTN007')}
                isShowClassnameButton={false}
            />
             {/* dialog close panel  */}
             <ConfirmDialog
                isOpen={isClosePanelProduct.isClose}
                msgConfirm={I18n.get('MSG-CM-CONFIRM-EXIT-PAGE-WITHOUT-SAVING')}
                okCallBack={async () =>
                    await onClickYesCancel(
                        props?.API,
                        editionList,
                        setEditionList,
                        setIsLoading,
                        setTriggerReload,
                        userDetail.id,
                        setIsEdit,
                        enqueueSnackbar,
                        setHasError,
                        setIsShowPopUpCancel,
                        hasError,
                        isEdit,
                        props.dataProduct.id,
                        setIsClosePanelProduct,
                        nameProduct,
                        setIsShowPopUpReload,
                        listVersionUpdated,
                        setNameProduct,
                        setListVersionUpdated
                    )
                }
                closeCallBack={() => {
                    closePanelTab({
                        event: null,
                        panelType: Constant.PANEL_TYPE.PRODUCT_MANAGEMENT,
                        panelId: props.panelId,
                        tabId: props.tabId
                        
                    })
                    setIsClosePanelProduct({isClose: false, componentType: ProductManagementConstant.EDITION_LIST})
                }
                    
                }
                cancelCallBack={() => {
                    setIsClosePanelProduct({isClose: false, componentType: ProductManagementConstant.EDITION_LIST});
                    
                }}
                textSubmit={I18n.get('COMBTN002')}
                textClose={I18n.get('COMBTN007')}
                isShowClassnameButton={false}
            />

            {/* dialog confirm 030 reload  */}
            <ConfirmDialog 
                isOpen={isShowPopUpReload.isOpen}
                msgConfirm={I18n.get('COMMSG030')}
                okCallBack={() =>
                    onReloadPage(
                        props.onOpenVersionList,
                        isShowPopUpReload,
                        setTriggerReload,
                        setIsShowPopUpReload,
                        setIsEdit,
                        setHasError,
                        setListVersionUpdated
                    )
                }
            />
        </div>
    );

}
